import React from "react";
import { formCardStyle } from "./form-card.css";
import { Space } from "./space";
import { Text } from "@vagastec/ensemble-core";

export function FormCard({ children, title, description, idTitle, ...rest }) {
  return (
    <div className={formCardStyle} {...rest}>
      <Text size="lg" weight={600} as="h2" id={idTitle}>
        {title}
      </Text>
      <Space />
      {description ? (
        <>
          <Text as="p">{description}</Text>
          <Space />
        </>
      ) : null}
      {children}
    </div>
  );
}
